import { FC } from 'react'
import { SvgProps } from './svgProps'

const AtIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 19}
    height={height || 19}
    viewBox="0 0 19 19"
  >
    <g id="web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="assety"
        transform="translate(-316.000000, -439.000000)"
        fill={color || '#FFF'}
        fillRule="nonzero"
      >
        <g id="Group-6" transform="translate(291.000000, 429.000000)">
          <g id="ic_email_share" transform="translate(25.000000, 10.000000)">
            <path
              d="M9.5,0 C4.261768,0 0,4.261768 0,9.5 C0,14.738232 4.261768,19 9.5,19 C11.1705067,19 12.8131587,18.5604831 14.2511623,17.7284312 L13.0625051,15.6723226 C11.9851851,16.2956478 10.7530126,16.6250102 9.5,16.6250102 C5.57106091,16.6250102 2.3749898,13.4289391 2.3749898,9.5 C2.3749898,5.57106091 5.57106091,2.3749898 9.5,2.3749898 C13.4289391,2.3749898 16.6250102,5.57106091 16.6250102,9.5 L16.6250102,10.5344164 C16.6250102,11.3114115 16.1257872,11.8749898 15.4374949,11.8749898 C14.7828484,11.8749898 14.2499796,11.342121 14.2499796,10.6874745 L14.2499796,5.9374949 L12.6084287,5.9374949 C11.7730327,5.20768564 10.6937551,4.74997961 9.5,4.74997961 C6.880884,4.74997961 4.74997961,6.880884 4.74997961,9.5 C4.74997961,12.119116 6.880884,14.2500204 9.5,14.2500204 C10.7472214,14.2500204 11.8748675,13.7567925 12.7233141,12.9677257 C13.377308,13.7449247 14.3445958,14.2500204 15.4374949,14.2500204 C17.4350393,14.2500204 19,12.6178088 19,10.5344164 L19,9.5 C19,4.261768 14.738232,0 9.5,0 Z M9.5,11.8749898 C8.19013613,11.8749898 7.1250102,10.8098231 7.1250102,9.5 C7.1250102,8.19013613 8.19017691,7.1250102 9.5,7.1250102 C10.8098639,7.1250102 11.8749898,8.19017691 11.8749898,9.5 C11.8749898,10.8098639 10.8098639,11.8749898 9.5,11.8749898 L9.5,11.8749898 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default AtIcon
